// libs
import React from 'react';
//components
import ProductDetails from '../ProductDetails/';
import ProductTable from '@/pages/instamart/campaign/details/widgets/ProductTable';
// widgets
import ProductChip from '@/widgets/ProductChip';
//dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
//constants
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
import { CampaignWriteModeEnum } from '@/stores/WriteCampaign/constants';
//styles
import style from './SelectedProducts.module.scss';
const SelectedProducts = ({ mode, selectedOptions, onDelete, preSelectedProducts, }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(Text, { variant: DlsFontVariants.button_Text_BT2, color: DlsColorTokens.text_Highest_Emphasis, className: style.title }, "Products selected by you"),
        React.createElement(Text, { variant: DlsFontVariants.body_B1_Reg, color: DlsColorTokens.text_Med_Emphasis, className: style.subTitle }, "These are the products which would show-up in your Ad"),
        mode === CampaignWriteModeEnum.EDIT ? (React.createElement(ProductTable, { mode: mode, productData: selectedOptions, onDelete: onDelete, preSelectedProducts: preSelectedProducts, showHeader: true })) : (React.createElement("div", { className: style.container }, selectedOptions.map((option) => {
            var _a;
            const { creativeId = '-', title = '-', description = '-', } = (_a = option.attributes) !== null && _a !== void 0 ? _a : {};
            return (React.createElement(ProductChip, { key: option.id },
                React.createElement(ProductDetails, { creativeId: creativeId, title: title, subTitle: description, onDelete: () => onDelete(option.id), showDelete: true, showRecentlyAddedBadge: false })));
        })))));
};
export default SelectedProducts;
